/* ============================================================================
   HYT L5 | "9 Reasons on a GLP-1" advertorial listicle.

   Three jobs only, because the page is a single column of copy plus one offer:
     1. print every price and percentage from pc-hyt-cart.js, never from markup
     2. run the deal clock the reference runs, evergreen
     3. keep the sticky bar and the cookie banner out of each other's way

   pc-hyt-cart.js must load FIRST. On the theme both are deferred in that order,
   and defer preserves order.
   ========================================================================== */
(function () {
  'use strict';

  var PC = window.PC_HYT;
  var root = document.querySelector('.hytl5') || document.body;

  /* ------------------------------------------------------------------ prices
     The offer is one size: Value, subscribed. Standard subscribed is $39.98,
     which sits under PC's $45 free shipping threshold, so a page that promises
     free shipping cannot be the one that sells Standard. The whole page reads
     off this one object. */
  var size = PC && PC.byKey('value');
  var sub, apart, off;

  function paint() {
    if (!size) return;                       // pc-hyt-cart.js missing, leave the markup as written
    sub   = PC.priceOf(size, true);
    apart = size.apart;
    off   = PC.pct(apart, sub);

    /* The offer card no longer prints a price (removed 2026-08-11 on Omar's
       instruction), so only the reason 9 sentence, the sticky bar and the
       percentage are painted. The percentage is still derived from sub and apart,
       which is why both are still read from the store. */
    var money = PC.money;
    set('[data-price-sub]',   money(sub));
    set('[data-cadence]',     size.cadenceLabel);
    set('[data-sticky-sub]',  money(sub) + ' subscribed, ships ' + size.cadenceLabel);

    /* 2026-09-02, Omar: the offer headline and both CTAs are hardcoded copy now.
       They used to be painted here from the computed percentage; that made the
       button follow the store price. The markup in hytl5-lander.liquid is the
       single source of truth for those three strings, so nothing writes over it.
       Do NOT reinstate these two writes without changing the Liquid to match.

         set('[data-off]',  'UP TO ' + off + '% OFF');
         each('[data-buy]', ...)

       `off` is still computed because the KNOWN checks and the debug getter below
       read it, and because the free shipping guard needs `sub` either way. */

    /* The free shipping row is state driven, not decorative: PC ships free over
       $45 and this page must not print the claim if the live price stops
       clearing it. */
    var ship = document.querySelector('[data-ship]') ||
               document.querySelector('.hytl5-risk span:last-child');
    if (ship && sub < PC.freeShipMin) ship.textContent = 'Shipping calculated at checkout';
  }

  function set(sel, text) {
    each(sel, function (el) { el.textContent = text; });
  }
  function each(sel, fn) {
    Array.prototype.forEach.call(root.ownerDocument.querySelectorAll(sel), fn);
  }

  /* ------------------------------------------------------------------- clock
     The reference runs a countdown in the deal bar and again on the offer card.
     Ours is evergreen: a 15 hour window per visitor, kept in localStorage so a
     reload does not reset it, restarted once it runs out. The footer says in
     plain words that it is a display timer and that Subscribe and Save is a
     standing discount, because pretending a permanent price expires tonight is
     the part that would not be true. */
  var WINDOW_MS = 15 * 60 * 60 * 1000;
  var KEY = 'pc_hyt_l5_deadline';

  function deadline() {
    var now = Date.now(), end = 0;
    try { end = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) { end = 0; }
    if (!end || end <= now || end - now > WINDOW_MS) {
      end = now + WINDOW_MS;
      try { localStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    return end;
  }

  var END = deadline();

  function two(n) { return (n < 10 ? '0' : '') + n; }

  function tick() {
    var left = Math.max(0, END - Date.now());
    var s = Math.floor(left / 1000);
    var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60);
    s = s % 60;
    set('[data-clock-h]', two(h));
    set('[data-clock-m]', two(m));
    set('[data-clock-s]', two(s));
    set('[data-deadline]', two(h) + ':' + two(m) + ':' + two(s));
    if (left <= 0) { END = deadline(); }      // evergreen: start the next window
  }

  /* ------------------------------------------------------------------ sticky
     An IntersectionObserver alone never fires on a page loaded at the top, so
     the visibility flag is cached and applied from a scroll listener too. */
  var sticky = document.querySelector('[data-sticky]');
  var offer  = document.getElementById('offer');

  function stickyState() {
    if (!sticky) return;
    var past = window.scrollY > window.innerHeight * 0.9;
    var atOffer = false;
    if (offer) {
      var r = offer.getBoundingClientRect();
      atOffer = r.top < window.innerHeight && r.bottom > 0;
    }
    var on = past && !atOffer;
    sticky.setAttribute('data-on', on ? '1' : '0');
    /* The consent banner is a third party app pinned to the bottom of the
       viewport, the same place this bar lives. On a phone they overlap and the
       Accept button ends up under the bar, so the banner is lifted only while
       the bar is actually showing. */
    document.body.classList.toggle('hytl5-bar-on', on);
  }

  /* No add to cart here any more. The CTAs are anchors to
     /pages/hyt-bundle-glp1-c, which owns the offer and its own cart
     wiring, so intercepting the click would only break the handover.
     pc-hyt-cart.js is still loaded: this page reads live prices from it. */

  paint();
  tick();
  setInterval(tick, 1000);
  stickyState();
  window.addEventListener('scroll', stickyState, { passive: true });
  window.addEventListener('resize', stickyState);

  /* Exposed for the headless checks, which assert against the numbers the page
     actually computed rather than against the numbers in the markup. */
  window.PC_HYT_L5 = {
    get price() { return { sub: sub, apart: apart, off: off, once: size && size.once }; },
    end: function () { return END; }
  };
})();
